import { RootState } from 'store/rootReducer';
import { selectorsFactory } from 'store/entities/utils';

export const channelsSlice = (state: RootState) => state.entities.channels;

export const channels = selectorsFactory.createStaticKeyWindowEntitiesMemoizedSelector(channelsSlice);

export const channelsState = selectorsFactory.createStaticKeyWindowStateMemoizedSelector(channelsSlice);
